import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './Stars.js';
import Icon from '@synergycms_core/components/generic/Icon';
import { contains, toLower, pipe, replace } from 'ramda';
import RichText from '@synergycms_core/components/generic/RichText';

export const HALF_STAR_TYPES = ['5GL', '4* SUPERIOR', '3* S', '3* SUPERIOR', '2* SUPERIOR'];

const Stars = class Stars extends React.Component {
  static displayName = 'Stars';
  render() {
    const { config, theme } = this.props;
    const starsRaw = config.stars || '';
    const { classes } = theme.styles;
    const showHalfStar = config.categoryType === 'half_stars' && HALF_STAR_TYPES.includes(starsRaw);

    if (config.type === 'string') {
      return (
        <span className={theme.computedInnerStyle}>
          <RichText text={replace(/\D/g, '', starsRaw)} innerStyle={classes.headerTitleNumber} />
          <Icon config={{ content: '*' }} innerStyle={['mainColor']} />
          <span className={classes.luxury}>
            {pipe(
              toLower,
              contains('gl')
            )(starsRaw) && 'GL'}
          </span>
        </span>
      );
    } else {
      const starsNum = parseInt(starsRaw.substring(0, 1), 10);
      const stars = '*'.repeat(starsNum);
      return (
        <span className={theme.computedInnerStyle}>
          <span className={classes.starsRow}>
            <Icon config={{ content: stars }} innerStyle={['mainColor']} />
            {showHalfStar && (
              <span className={classes.halfStarContainer}>
                <Icon config={{ content: '*' }} innerStyle={['mainColor', classes.halfStar]} />
              </span>
            )}
          </span>
        </span>
      );
    }
  }
};
export default compose(
  PropertyManager(['stars', 'type', 'categoryType']),
  withThemeJSS({ styleFile })
)(Stars);

/*
<Stars count>
  <List>
    <Icon />
  </List>
  <RichText /> <-! optional GL if count > 5 -->
</Stars>
*/
